import React, {useState, useEffect} from "react";
import classNames from "classnames";

//material-ui
import {withStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {lighten} from "@material-ui/core/styles/colorManipulator";
import Typography from "@material-ui/core/Typography";
import {Icon} from "../styles/table_styles";
import remove from "../images/icons8-x.png";
import greencheck from "../images/green-checkmark-24.png";
import minus from "../images/icons8-minus.png";
import checkmark from "../images/icons8-checkmark.png";

import {
  Label
} from "../styles/selection_group_styles";

import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
  container: {
    marginBottom: 0
  },
  table: {
    minWidth: 400,
    maxWidth: "auto"
  },
  head: {
    fontFamily: ["Rubik", "sans-serif"].join(","),
    backgroundImage:
      "linear-gradient(to right, #020d39, #012e58, #134e75, #307190, #5394a9);"
  },
  head_cell: {
    fontFamily: ["Rubik", "sans-serif"].join(","),
    color: "white",
    fontWeight: "600",
    fontSize: "1em"
  },
  cell: {
    fontWeight: "400",
    fontSize: "1em",
    fontFamily: ["Rubik", "sans-serif"].join(",")
  }
});

export default function Table2({inputId, activeStep, data}) {
  let columns = [
    {name: "origin", title: "Operator"},
    {name: "sentence", title: "Augmented Sentence"},
    {name: "label", title: "Label"},
    {name: "label_icon", title: "Label Accuracy"},
    {name: "filter", title: "Filter"},
    {name: "weight", title: "Weight"}
  ];

  let input_data = data[inputId].augment;
  input_data.forEach((aug) => {
    if (!aug.in_batch) {
      aug.filter = <Icon src={remove} alt="removed" />;
      aug.weight = <Icon src={minus} alt="not weighted" />;
    } else if(aug.in_batch){
        aug.filter = <Icon src={greencheck} alt="accepted" />;
    }
    if(!aug.label_accurate){
      aug.label_icon = <Icon src = {remove} alt="incorrect" />;
    } else if(aug.label_accurate){
        aug.label_icon = <Icon src={greencheck} alt="correct" />;
    }

  });

  const classes = useStyles();

  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table className={classes.table} aria-label="cluster table">
        <TableHead className={classes.head}>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.name}
                align="center"
                className={classes.head_cell}
              >
                {column.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {input_data.map((row, i) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={i}
                align="left"
                value={row}
              >
              {columns.map((column, t) => (
                column.name === "label" ?
                <TableCell
                  className={classes.cell}
                  align="center"
                  key={t}
                >
                  <Label color={row.color} > {row[column.name]}{" "} </Label>
                </TableCell>
                :
                <TableCell
                  className={classes.cell}
                  align="center"
                  key={t}
                >
                {row[column.name]}{" "}
                </TableCell>
              )
            )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
